import {
  ADD_RFID_CARD_REQUEST,
  ADD_RFID_CARD_SUCCESS,
  ADD_RFID_CARD_FAIL,
  UPDATE_RFID_CARD_REQUEST,
  UPDATE_RFID_CARD_SUCCESS,
  UPDATE_RFID_CARD_FAIL,
  DELETE_RFID_CARD_REQUEST,
  DELETE_RFID_CARD_SUCCESS,
  DELETE_RFID_CARD_FAIL,
  APPROVE_DELETE_RFID_CARD_REQUEST,
  APPROVE_DELETE_RFID_CARD_SUCCESS,
  APPROVE_DELETE_RFID_CARD_FAIL,
  CANCEL_DELETE_RFID_CARD_REQUEST,
  CANCEL_DELETE_RFID_CARD_SUCCESS,
  CANCEL_DELETE_RFID_CARD_FAIL,
  RESET_RFID_CARD_REQUEST,
  RESET_RFID_CARD_SUCCESS,
  RESET_RFID_CARD_FAIL,
  APPROVE_RESET_RFID_CARD_REQUEST,
  APPROVE_RESET_RFID_CARD_SUCCESS,
  APPROVE_RESET_RFID_CARD_FAIL,
  CANCEL_RESET_RFID_CARD_REQUEST,
  CANCEL_RESET_RFID_CARD_SUCCESS,
  CANCEL_RESET_RFID_CARD_FAIL,
  GET_RFID_CARD_LIST_REQUEST,
  GET_RFID_CARD_LIST_SUCCESS,
  GET_RFID_CARD_LIST_FAIL,
  GET_SINGLE_RFID_CARD_REQUEST,
  GET_SINGLE_RFID_CARD_SUCCESS,
  GET_SINGLE_RFID_CARD_FAIL,
  GET_RFID_CARD_HISTORY_REQUEST,
  GET_RFID_CARD_HISTORY_SUCCESS,
  GET_RFID_CARD_HISTORY_FAIL,
  GET_RFID_NUMBER_FROM_DEVICE_REQUEST,
  GET_RFID_NUMBER_FROM_DEVICE_SUCCESS,
  GET_RFID_NUMBER_FROM_DEVICE_FAIL,
  GET_RFID_CARD_FROM_NUMBER_REQUEST,
  GET_RFID_CARD_FROM_NUMBER_SUCCESS,
  GET_RFID_CARD_FROM_NUMBER_FAIL,
  RESET_RFID_NUMBER_REQUEST,
  RESET_RFID_NUMBER_SUCCESS,
  RESET_RFID_NUMBER_FAIL,
  RESET_SINGLE_RFID_CARD_REQUEST,
  RESET_SINGLE_RFID_CARD_SUCCESS,
  RESET_SINGLE_RFID_CARD_FAIL,
} from "src/constants/types";

export const rfidCardReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_RFID_CARD_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_RFID_CARD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCards: actions.payload,
        error: "",
      };

    case GET_RFID_CARD_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_SINGLE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCard: actions.payload,
      };

    case GET_SINGLE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case ADD_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case ADD_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case UPDATE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case UPDATE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case DELETE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case DELETE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case APPROVE_DELETE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case APPROVE_DELETE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case APPROVE_DELETE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case CANCEL_DELETE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case CANCEL_DELETE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case CANCEL_DELETE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case RESET_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case RESET_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case RESET_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case APPROVE_RESET_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case APPROVE_RESET_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case APPROVE_RESET_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case CANCEL_RESET_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case CANCEL_RESET_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case CANCEL_RESET_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_RFID_CARD_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_RFID_CARD_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCardHistory: actions.payload,
        error: "",
      };

    case GET_RFID_CARD_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_RFID_NUMBER_FROM_DEVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_RFID_NUMBER_FROM_DEVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidNumberFromDevice: actions.payload,
        error: "",
      };

    case GET_RFID_NUMBER_FROM_DEVICE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_RFID_CARD_FROM_NUMBER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_RFID_CARD_FROM_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCardFromNumber: actions.payload,
        error: "",
      };

    case GET_RFID_CARD_FROM_NUMBER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case RESET_RFID_NUMBER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case RESET_RFID_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidNumberFromDevice: null,
        error: "",
      };

    case RESET_RFID_NUMBER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case RESET_SINGLE_RFID_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case RESET_SINGLE_RFID_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        rfidCardFromNumber: null,
        error: "",
      };

    case RESET_SINGLE_RFID_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
